<template>
  <div class="barra-busca-produtos">
    <b-row class="resumos-filiais">
      <b-col md="2"></b-col>
      <b-col md="10">
        <div class="lista-resumos-filiais">
          <div v-if="temSegundaColuna" class="resumo-filial">
            <slot name="segundaColuna"></slot>
          </div>
          <div v-if="temTerceiraColuna" class="resumo-filial">
            <slot name="terceiraColuna"></slot>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="align-items-end controles-busca">
      <b-col md="2"></b-col>
      <b-col md="10" class="text-md-right">
        <b-form-checkbox
          id="produtos-favoritos"
          name="produtos-favoritos"
          class="filtro-produtos-favoritos"
          :checked="somenteFavoritos"
          :value="true"
          :unchecked-value="false"
          @change="$emit('alterarFavoritos', $event)"
        >
          <span>
            <b>Produtos Favoritos </b>
            <i
              class="fa fa-question-circle"
              title="Selecione os itens clicando na estrela e utilize esse recurso para filtrar somente os itens que voce definir como favoritos. Para retirar da lista, basta desmarcar o item clicando novamente na estrela."
            ></i>
          </span>
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-row class="align-items-start campo-busca-row">
      <b-col md="2"></b-col>
      <b-col md="10" class="mb-2">
        <div ref="areaBusca" class="area-busca">
          <div class="campo-busca">
            <i class="fa fa-search icone-busca"></i>
            <b-form-input
              ref="entradaBusca"
              :value="termoBusca"
              class="entrada-busca"
              placeholder="Buscar produto por nome, código..."
              @input="$emit('alterarTermo', $event)"
              @keyup="$emit('teclaBusca', $event)"
            />
            <button
              v-if="temTermoBusca"
              type="button"
              class="acao-limpar-busca"
              aria-label="Limpar busca"
              @click="$emit('limparBusca')"
            >
              <i class="fa fa-close"></i>
            </button>
            <b-spinner
              v-if="carregandoSugestoes"
              small
              class="carregando-sugestoes"
            ></b-spinner>
          </div>

          <b-list-group
            v-if="mostrarSugestoes && sugestoes.length > 0"
            class="sugestoes-busca"
          >
            <b-list-group-item
              v-for="(sugestao, indice) in sugestoes"
              :key="`${indice}-${sugestao}`"
              class="item-sugestao"
              @click="$emit('usarSugestao', sugestao, indice)"
            >
              {{ sugestao }}
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "barraBuscaProdutos",
  props: {
    mostrarSegundaColuna: {
      type: Boolean,
      default: null,
    },
    mostrarTerceiraColuna: {
      type: Boolean,
      default: null,
    },
    somenteFavoritos: Boolean,
    termoBusca: {
      type: String,
      default: "",
    },
    carregandoSugestoes: Boolean,
    mostrarSugestoes: Boolean,
    sugestoes: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    temSegundaColuna() {
      if (this.mostrarSegundaColuna !== null) {
        return this.mostrarSegundaColuna;
      }
      return !!(this.$scopedSlots.segundaColuna || this.$slots.segundaColuna);
    },
    temTerceiraColuna() {
      if (this.mostrarTerceiraColuna !== null) {
        return this.mostrarTerceiraColuna;
      }
      return !!(this.$scopedSlots.terceiraColuna || this.$slots.terceiraColuna);
    },
    temTermoBusca() {
      return String(this.termoBusca || "").trim() !== "";
    },
  },
  mounted() {
    document.addEventListener("click", this.verificarCliqueExterno);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.verificarCliqueExterno);
  },
  methods: {
    verificarCliqueExterno(evento) {
      if (this.$refs.areaBusca && !this.$refs.areaBusca.contains(evento.target)) {
        this.$emit("fecharSugestoes");
      }
    },
    focarBusca() {
      if (this.$refs.entradaBusca) {
        this.$refs.entradaBusca.focus();
      }
    },
    desfocarBusca() {
      const entradaBusca = this.$refs.entradaBusca;
      if (!entradaBusca) {
        return;
      }

      if (typeof entradaBusca.blur === "function") {
        entradaBusca.blur();
        return;
      }

      if (entradaBusca.$el && typeof entradaBusca.$el.blur === "function") {
        entradaBusca.$el.blur();
      }
    },
  },
};
</script>

<style>
.lista-resumos-filiais .dropdown-toggle {
  font-size: 12px;
  height: 34px;
  min-height: 34px;
  padding: 0.35rem 0.75rem;
}

.lista-resumos-filiais .badge {
  font-size: 11px;
  padding: 0.2rem 0.35rem;
}
</style>

<style scoped>
.barra-busca-produtos {
  background: #fff;
  padding: 15px 0 8px;
  position: sticky;
  top: 55px;
  z-index: 3;
}

.resumos-filiais {
  margin-bottom: 0.75rem;
}

.lista-resumos-filiais {
  display: flex;
  gap: 30px;
  justify-content: flex-end;
}

.resumo-filial {
  flex: 0 1 31%;
  max-width: 380px;
  min-width: 220px;
}

.controles-busca {
  min-height: 41px;
}

.filtro-produtos-favoritos {
  color: #343a40;
  display: inline-block;
  font-size: 12px;
  margin-bottom: 0.55rem;
}

.area-busca,
.campo-busca {
  position: relative;
}

.entrada-busca {
  border: 1px solid #dfe4ea;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(36, 50, 66, 0.06);
  font-size: 13px;
  height: 54px;
  padding-left: 2.75rem;
  padding-right: 3rem;
}

.entrada-busca:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.15rem rgba(0, 123, 255, 0.15);
}

.icone-busca {
  color: #9aa6b5;
  font-size: 15px;
  left: 1rem;
  position: absolute;
  top: 1.2rem;
  z-index: 3;
}

.acao-limpar-busca {
  background: transparent;
  border: 0;
  color: #7d8790;
  cursor: pointer;
  padding: 0;
  position: absolute;
  right: 1rem;
  top: 1.05rem;
  z-index: 3;
}

.carregando-sugestoes {
  position: absolute;
  right: 2.25rem;
  top: 1.05rem;
  z-index: 3;
}

.sugestoes-busca {
  background: #fff;
  border: 1px solid #c3c3c3;
  border-radius: 4px;
  margin-top: 1px;
  padding: 2px;
  position: absolute;
  top: 57px;
  width: 100%;
  z-index: 4;
}

.item-sugestao {
  border: none;
  border-bottom: 1px solid #efefef !important;
  cursor: pointer;
  font-size: 14px !important;
  margin-bottom: 0;
  padding: 10px 20px !important;
}

.item-sugestao:last-child {
  border-bottom: 0 !important;
}

.item-sugestao:hover {
  background-color: #d2e2ff;
  text-decoration: none;
}

@media (max-width: 1023px) {
  .resumos-filiais {
    margin-bottom: 0.5rem;
  }

  .lista-resumos-filiais {
    flex-direction: column;
    gap: 0.5rem;
  }

  .resumo-filial {
    max-width: none;
    min-width: 0;
    width: 100%;
  }

  .filtro-produtos-favoritos {
    margin-bottom: 0.75rem;
  }
}
</style>
